/*
 * BuroEcl
 * Copyright (c) 2023 Buroclic. All rights reserved.
 * 
 * This file corresponds to the breadcrumb displayed
 * when the user is located inside of a specific chemise
 */

// Imports
import PropTypes from "prop-types";

// Interfaces
import { LevelChemise, Mission } from "../../../interfaces/IDossiers";
import { PublicCabinet } from "../../../interfaces/ICabinets";

export const Breadcrumb = (props) => {
    const levels: Array<LevelChemise> = props.chemisePath || [] as Array<LevelChemise>;
    const mission = props.mission || {} as Mission;
    
    const cabinet = (JSON.parse(localStorage.getItem('cabinet') || "{}") as PublicCabinet);

    return (
        <div className={`w-full flex flex-row h-8 items-center pl-4 bg-[#FBFBFB] shadow-md border-b`} style={{borderColor: cabinet.color}}>
            <div className="flex">
                {mission?.MIS_REF ?
                <span tabIndex={30} onClick={() => props.handleChemiseEdit(0)} className="cursor-pointer font-medium" style={{lineHeight: '1.7rem'}}>Mission {mission.MIS_CODE} - {mission.MIS_LIBELLE} <span className="mx-2 text-xl">»</span></span>
                :
                <></>}
            </div>
            {levels?.map((level, index) => (
                    <div  key={level.id} className="flex">
                        <div>
                            {index > 0 ? <span className="mx-2 text-xl">»</span> : <></> }
                            <span tabIndex={30 + index} onClick={() => props.handleChemiseEdit(level.id)} className="cursor-pointer font-medium" style={{lineHeight: '1.7rem'}}>{index === 0 && !mission.MIS_REF ? 'Chemise ' : ''}{level.nom}</span>
                        </div>
                    </div>
                ))}
        </div>
    );
}

Breadcrumb.protoTypes = {
    chemisePath: PropTypes.arrayOf(PropTypes.object).isRequired,
    handleChemiseEdit: PropTypes.func.isRequired,
    mission: PropTypes.object
}